module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0007.jpg?v=119c6dc3";